import React, { useReducer, useEffect} from 'react'
import { refreshCurrentAccountWrapperInFunctionalComponent } from '../services/session/sessionState'
import { getUserAccountsSingleton } from '../services/userAccountsSingleton.service'


export const UserAccountsContext = React.createContext(null)

const UserAccountsProvider = (props) => {
  const [userAccounts, setUserAccounts] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const load = React.useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await getUserAccountsSingleton()
      setUserAccounts(data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [])
  const [, forceUpdate] = useReducer((x) => x + 1, 0)
  useEffect(() => {
    refreshCurrentAccountWrapperInFunctionalComponent(forceUpdate, props)
    const interval = setInterval(() => {
      load()
      clearInterval(interval)
    }, 1000)

    return () => clearInterval(interval)
  }, [load])

  const { children } = props
  return (
    <UserAccountsContext.Provider
      value={{
        userAccounts: userAccounts,
        loading: loading,
      }}
    >
      {children}
    </UserAccountsContext.Provider>
  )
}

export const withUserAccountsContext = (Component) => (props) => (
  <UserAccountsContext.Consumer>
    {(context) => <Component userAccountsContext={context} {...props} />}
  </UserAccountsContext.Consumer>
)

export default UserAccountsProvider
